import { render, staticRenderFns } from "./UserProfileDrawer.vue?vue&type=template&id=471be966&scoped=true"
import script from "./UserProfileDrawer.vue?vue&type=script&lang=js"
export * from "./UserProfileDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserProfileDrawer.vue?vue&type=style&index=0&id=471be966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471be966",
  null
  
)

export default component.exports